<template>
  <div class="flex flex-col w-1/2" :class="getContainerClass()">
    <label for="select-country" v-if="country" class="text-sm text-blackish mb-1 pl-2">
      {{ $t('addressForm.country') }}
    </label>
    <div class="relative flex items-center">
      <select id="select-country"
        class="border-b pl-1 w-full border-gray-400 outline-none appearance-none" :class="getLabelClass()"
        v-model="country" @change="selectCountry()">
          <option :value="null" disabled>{{ $t('addressForm.country') }}</option>
          <option v-for="country in countries" :key="country.code" :value="country.code.toUpperCase()">{{country.name}}</option>
      </select>
      <dropdown-arrow class="absolute right-0 pointer-events-none" />
    </div>
    <span v-if="show" class="italic text-b2c-red-300 text-sm pt-1">{{$t('input.fillField')}}</span>
  </div>

</template>

<script>
import countriesList from '@/config/countries-list';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';

export default {
  props: ['value', 'showMessage'],

  data() {
    return {
      country: null,
    };
  },

  mounted() {
    if (this.value) {
      this.country = this.value;
    }
  },

  components: {
    DropdownArrow,
  },

  computed: {
    countries() {
      return countriesList[this.$i18n.locale];
    },
    show() {
      return this.showMessage && !this.country;
    },
  },

  methods: {
    selectCountry() {
      this.$emit('input', this.country);
    },

    getLabelClass() {
      if (!this.country) {
        return `text-sm py-2 ${this.fontHairline()}`;
      }
      return 'py-1';
    },

    getContainerClass() {
      if (!this.country) {
        return 'mt-6';
      }
      return 'mt-2';
    },
  },
};
</script>
